import { render, staticRenderFns } from "./SchoolClassAddEdit.vue?vue&type=template&id=14e4d1ca"
import script from "./SchoolClassAddEdit.vue?vue&type=script&lang=js"
export * from "./SchoolClassAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports